const initialState = {
  useHistory: null
}

const utils = (state = initialState, action) => {
  switch (action.type) {
    case "USEHISTORY":
      return { ...state, useHistory: action.val }
    default:
      return state
  }
}
export default utils
